import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { OnboardingDialogsContext } from "contexts/OnboardingDialogs";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { routes } from "schemas/routes";

import { isPage } from "utils/general";
import { trackEvent } from "utils/tracking";

export default function CompleteOnboardingDialog() {
  const {
    setProfileDialogOpen,
    setCreateTemplateOnboardingDialogOpen,
    completeOnboardingDialogOpen,
    setCompleteOnboardingDialogOpen,
    incompleteProfile,
    noTemplates,
  } = useContext(OnboardingDialogsContext);
  const location = useLocation();

  const handleClose = () => {
    trackEvent("Onboarding Action Items Dialog Closed", {
      route: location.pathname,
    });
    setCompleteOnboardingDialogOpen(false);
  };

  return (
    <Dialog open={completeOnboardingDialogOpen} onClose={handleClose}>
      <IconButton
        sx={{
          color: "primary.main",
          fontSize: 14,
          position: "absolute",
          right: 10,
          top: 10,
        }}
        onClick={handleClose}
      >
        <Box component="i" className="fa-regular fa-xmark" />
      </IconButton>
      <DialogTitle>
        <Grid container justifyContent="center">
          <Typography variant="h5">
            <Box
              component="i"
              className="fa-solid fa-hand"
              sx={{ pr: 0.5, color: "secondary.main" }}
            />{" "}
            Action Items to Complete First!
          </Typography>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ p: 4 }}>
        <Typography paragraph sx={{ mt: 3 }}>
          {isPage(routes.recommendations)
            ? "To get personalized recommendations"
            : "Before you can create a campaign"}
          , we first need to understand who you are and what you like.
          Completing your profile and creating your first pitch template helps
          us gather that information, so we can tailor recommendations just for
          you.
        </Typography>
        {incompleteProfile && noTemplates && (
          <>
            <Typography paragraph>Here's what you need to do:</Typography>
            <ul>
              <li>
                <Typography>Finish filling out your profile</Typography>
              </li>
              <li>
                <Typography>Create your first pitch template</Typography>
              </li>
            </ul>
          </>
        )}
        <Typography paragraph sx={{ mb: 4 }}>
          Once these steps are complete,{" "}
          {isPage(routes.recommendations)
            ? `we'll be able to provide you with brand
          recommendations with pre-written email drafts that are a perfect fit
          for you!`
            : `you'll be able to create a campaign to pitch to brands more effectively!`}
        </Typography>
        <Box display="flex" justifyContent="center">
          <Button
            onClick={() => {
              if (incompleteProfile) {
                setProfileDialogOpen(true);
              } else {
                setCreateTemplateOnboardingDialogOpen(true);
              }
              trackEvent("Onboarding Action Items Dialog Get Started", {
                route: location.pathname,
              });
              setCompleteOnboardingDialogOpen(false);
            }}
            disableElevation
            variant="contained"
          >
            Get Started
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
